// src/hooks/useLeadSourceCache.js
import leadSourceService from "../../components/Services/LeadSourceService";

const LEAD_SOURCE_KEY = "leadSources";
const LAST_UPDATED_KEY = "leadSourcesLastUpdated";
const THIRTY_MINUTES = 5 * 60 * 1000;

export const fetchAndCacheLeadSources = async (force = false) => {
  try {
    const now = Date.now();
    const lastUpdated = localStorage.getItem(LAST_UPDATED_KEY);

    if (!force && lastUpdated && now - parseInt(lastUpdated, 10) < THIRTY_MINUTES) {
      return;
    }

    const res = await leadSourceService.getAllLeadSource();
    const data = res.data.leadSources;
    console.log("Fetched lead sources:", data);

    localStorage.setItem(LEAD_SOURCE_KEY, JSON.stringify(data));
    localStorage.setItem(LAST_UPDATED_KEY, now.toString());

  } catch (error) {
    console.error("Failed to fetch lead sources:", error);
  }
};


export const getLeadSourcesFromCache = () => {
  const data = localStorage.getItem(LEAD_SOURCE_KEY);
  return data ? JSON.parse(data) : [];
};
